import {
	createFileRoute,
	Navigate,
	useRouteContext,
} from "@tanstack/react-router";

export const Route = createFileRoute("/_logged/c/$club/(standalone)/regras")({
	component: RouteComponent,
});

function RouteComponent() {
	const { club } = useRouteContext({ from: "/_logged/c/$club" });
	return (
		<Navigate
			to="/c/$club/moderacao/regras"
			params={{ club: club.slug }}
			replace
		/>
	);
}
